import {UsimOrdersResponse} from "../schemas/UsimOrdersResponse";

function saveLocalUsimData(data : UsimOrdersResponse) {

  localStorage.setItem("usimLocalData", JSON.stringify(data));
}


function loadLocalUsimData() {
  const item = localStorage.getItem("usimLocalData");

  if (!item) return null;  // nothing stored

  const parsed = JSON.parse(item);


  // Return the actual saved data
  return parsed;
}

export { saveLocalUsimData, loadLocalUsimData };
